import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useOrganization } from 'src/graphql/hooks'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

// =======================================================
// Component
// =======================================================

const Logo = ({ flex, justifyContent }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const { organization } = useOrganization()
   const { [theme.globalNavLogoFieldName]: logo, theme: organizationTheme } = organization
   const logoUrl = logo?.file?.thumbnailUrlW240
   let { logoSize } = organizationTheme

   if (!logoSize && logo) {
      const logoAspectRatio = logo.file.width / logo.file.height
      if (logoAspectRatio > 6) {
         logoSize = 2
      } else if (logoAspectRatio < 6 && logoAspectRatio > 1.5) {
         logoSize = 4
      } else if (logoAspectRatio < 1.5) {
         logoSize = 6
      }
   }

   return (
      <View
         display="flex"
         height="60px[a-b] 80px[c-d] 85px[e-f]"
         maxWidth="100%[a-b] 50%[c-f]"
         flex={flex}
         alignItems="center"
         justifyContent={justifyContent}>
         <NavLink to="/" style={{ float: 'left', width: '100%' }}>
            {!logoUrl && (
               <View width="100%" paddingBottom="3px">
                  <Text size="3[a-d] 4[e-f]" weight="medium" color="#222">
                     {organization.name}
                  </Text>
               </View>
            )}
            {logoUrl && (
               <View
                  float="left"
                  display="block"
                  flex="0 0 auto"
                  height={`
                     ${10 + (logoSize * 3)}px[a-b]
                     ${8 + (logoSize * 4)}px[c-d]
                     ${6 + (logoSize * 5)}px[e-f]
                  `}>
                  <img
                     alt={organization.name}
                     src={logoUrl}
                     height="100%"
                  />
               </View>
            )}
         </NavLink>
      </View>
   )
}

Logo.propTypes = {
   flex: PropTypes.string,
   justifyContent: PropTypes.string
}

Logo.defaultProps = {
   flex: '0 0 auto',
   justifyContent: 'flex-start'
}

export default Logo
